import { AuthenticatedApp } from '@room/shared-ui';
import { DocsPage } from './pages/DocsPage';

export function App() {
  return (
    <AuthenticatedApp appName="Docs">
      <DocsPage />
    </AuthenticatedApp>
  );
}
